import { Controller } from "@hotwired/stimulus"

// Asumiendo Bootstrap 4 con jQuery (lo típico en Rails + bootstrap 4)
export default class extends Controller {
  static targets = ["modal", "phone", "message"]

  open(event) {
    event.preventDefault()

    const button  = event.currentTarget
    const phone   = button.dataset.phone
    const message = button.dataset.message

    this.phoneTarget.value   = phone || ""
    this.messageTarget.value = message || ""

    // Mostrar modal (Bootstrap 4)
    $('#whatsappModal').modal('show')
  }

  abrirWhatsapp(event) {
    event.preventDefault()

    const phone   = this.phoneTarget.value.trim()
    const message = this.messageTarget.value.trim()

    if (!phone) {
      alert("No hay un teléfono válido para WhatsApp.")
      return
    }

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    window.open(url, "_blank")

    // Opcional: cerrar el modal después de abrir WhatsApp
    $('#whatsappModal').modal('hide')
  }
}
